import React from 'react';
import { cantones } from '../data/mockData';
export function Footer() {
  return <footer className="relative z-10 pt-16 pb-8 px-4 border-t border-border bg-bg-secondary" data-id="element-68">
      <div className="max-w-7xl mx-auto" data-id="element-69">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-70">
          <div data-id="element-71">
            <img src="https://cdn.magicpatterns.com/uploads/nazWxRr8f6e5uH7jzbqQFC/Distrito_LS_logo.png" alt="Distrito LS" className="h-20 w-auto mb-4" data-id="element-72" />
            <p className="font-body text-text-muted mb-6 max-w-sm leading-relaxed" data-id="element-73">
              Donde Los Santos viene a comer. Descubrí, explorá y disfrutá de la
              mejor gastronomía de la Zona de Los Santos.
            </p>
          </div>

          <div data-id="element-74">
            <h3 className="font-heading text-xl tracking-wide mb-4 text-brand-gold" data-id="element-75">
              Cantones
            </h3>
            <ul className="space-y-2 font-body text-sm text-text-muted" data-id="element-76">
              {cantones.map(canton => <li key={canton.id} data-id="element-77">
                  <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-78">
                    {canton.fullName}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-79">
            <h3 className="font-heading text-xl tracking-wide mb-4 text-brand-gold" data-id="element-80">
              Enlaces
            </h3>
            <ul className="space-y-2 font-body text-sm text-text-muted" data-id="element-81">
              <li data-id="element-82">
                <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-83">
                  Para Restaurantes
                </a>
              </li>
              <li data-id="element-84">
                <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-85">
                  Sobre Nosotros
                </a>
              </li>
              <li data-id="element-86">
                <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-87">
                  Contacto
                </a>
              </li>
              <li data-id="element-88">
                <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-89">
                  Términos y Condiciones
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-90">
          <p className="font-body text-text-muted text-sm" data-id="element-91">
            © {new Date().getFullYear()} Distrito LS — Street Food Empire.
            Todos los derechos reservados.
          </p>
          <p className="font-body text-text-muted text-sm" data-id="element-92">
            Hecho en Costa Rica 🇨🇷
          </p>
        </div>
      </div>
    </footer>;
}